// ponytail: stand-in for the <internal-video> element from Shrine Pro's missing global.js. Remove once those assets are restored.
if (!customElements.get('internal-video')) {
  customElements.define('internal-video', class extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector('video');
      const playBtn = this.querySelector('.internal-video__play');
      const soundBtn = this.querySelector('.internal-video__sound-btn');
      const timeline = this.querySelector('.internal-video__timeline');
      if (!video) return;

      const play = () => {
        this.classList.add('internal-video--loading');
        video.play()
          .then(() => this.classList.add('internal-video--playing'))
          .catch((err) => console.error('Video failed to play:', video.currentSrc, err))
          .finally(() => this.classList.remove('internal-video--loading'));
      };
      const setMuted = (muted) => {
        video.muted = muted;
        this.classList.toggle('internal-video--muted', muted);
      };

      if (this.dataset.autoplay === 'true') {
        this.querySelectorAll('source[data-src]').forEach((s) => (s.src = s.dataset.src));
        video.load();
        setMuted(true);
        play();
      }

      playBtn?.addEventListener('click', () => {
        if (video.muted && !video.paused) return setMuted(false);
        if (video.paused) return play();
        video.pause();
        this.classList.remove('internal-video--playing');
      });
      soundBtn?.addEventListener('click', () => setMuted(!video.muted));
      if (timeline) {
        video.addEventListener('timeupdate', () => {
          if (video.duration) timeline.style.setProperty('--completed', (video.currentTime / video.duration) * 100 + '%');
        });
        timeline.addEventListener('click', (e) => {
          const r = timeline.getBoundingClientRect();
          if (video.duration) video.currentTime = ((e.clientX - r.left) / r.width) * video.duration;
        });
      }
    }
  });
}
